import React from "react";

import { dice1, dice2, dice3, dice4, dice5, dice6 } from "./Icons";

export default function Die({ randomObj, onHoldDice }) {
    const { value, isHeld, id } = randomObj;
    return (
        <div
            className={`die - face ${isHeld && "held"} `}
            onClick={() => onHoldDice(id)}
        >
            {value === 1 &&
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="dice-icon">{dice1}</svg>
            }
            {value === 2 &&
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="dice-icon">{dice2}</svg>

            }
            {value === 3 &&
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="dice-icon">{dice3}</svg>

            }
            {value === 4 &&
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="dice-icon">{dice4}</svg>

            }
            {value === 5 &&
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="dice-icon">{dice5}</svg>

            }
            {value === 6 &&
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="dice-icon">{dice6}</svg>

            }
        </div >
    );
}
